import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/layout/AdminLayout';
import { Button } from '../../components/ui/Button';
import { buildApiUrl } from '../../config/api';
import { authService } from '../../services/authService';
import { toast } from 'react-hot-toast';

type Business = { id: string; name: string; billingEmail?: string };

const Subscriptions: React.FC = () => {
  const token = authService.getToken();
  const [businesses, setBusinesses] = useState<Business[]>([]);
  const [formById, setFormById] = useState<Record<string, { monthlyPricePence: number; billingEmail: string; name: string }>>({});

  const fetchBusinesses = async () => {
    try {
      const res = await fetch(buildApiUrl('/admin/business-accounts'), { headers: { Authorization: `Bearer ${token}` } });
      const json = await res.json();
      if (!res.ok) throw new Error(json.message || 'Failed to load');
      setBusinesses(json.data || []);
    } catch (e: any) { toast.error(e.message || 'Failed to load'); }
  };

  useEffect(()=>{ fetchBusinesses(); }, []);

  const updateSub = async (id: string) => {
    const f = formById[id];
    if (!f || !f.billingEmail) return toast.error('Enter price and billing email');
    try {
      const res = await fetch(buildApiUrl(`/admin/business-accounts/${id}/subscription`), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(f),
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.message || 'Update failed');
      toast.success('Subscription updated');
    } catch (e: any) { toast.error(e.message || 'Failed to update'); }
  };

  return (
    <AdminLayout title="Subscriptions">
      <div className="space-y-6">
        <div className="text-sm text-gray-600">Set a monthly fee per company. VAT is currently 0%.</div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
          {businesses.map(b => (
            <div key={b.id} className="border rounded-xl p-5 bg-white shadow-sm">
              <div className="text-lg font-semibold text-gray-900">{b.name}</div>
              <div className="mt-4 grid grid-cols-1 gap-3">
                <input type="number" className="border rounded-lg px-3 py-2" placeholder="Monthly price (pence)" value={formById[b.id]?.monthlyPricePence || ''} onChange={e=>setFormById(prev=>({ ...prev, [b.id]: { ...prev[b.id], monthlyPricePence: Number(e.target.value) || 0, billingEmail: prev[b.id]?.billingEmail || '', name: b.name } }))} />
                <input className="border rounded-lg px-3 py-2" placeholder="Billing email" value={formById[b.id]?.billingEmail || ''} onChange={e=>setFormById(prev=>({ ...prev, [b.id]: { ...prev[b.id], billingEmail: e.target.value, monthlyPricePence: prev[b.id]?.monthlyPricePence || 0, name: b.name } }))} />
                <Button onClick={()=>updateSub(b.id)}>Save Subscription</Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
};

export default Subscriptions;


